module.exports = __webpack_public_path__ + "static/feature-dashboard-d853a0481fb7f2f2de5da028dc49fd89.png";